








































































































import {useGetters} from "vuex-composition-helpers";
import {computed, defineComponent} from "@vue/composition-api";
import ButtonLinkAtom from "@/shared/components/atoms/card/ButtonLinkAtom.vue";
import {useAuthenticationExchangeBus} from "@/shared/composables/authenticationExchangeBus";

export default defineComponent({
  name: "AuthenticationComponent",
  components: { ButtonLinkAtom },
  setup: () => {
    const { endpoints } = useGetters(["endpoints"]);
    const { labels } = useGetters(["labels"]);
    const authBus = useAuthenticationExchangeBus();

    const addFavoriteStudyParam = (baseUrl: string) => {
      if (!authBus.favoriteStudyCode) {
        return baseUrl;
      }

      const separator = baseUrl.includes('?') ? '&' : '?';
      return `${baseUrl}${separator}favorite_study=${encodeURIComponent(authBus.favoriteStudyCode)}`;
    };

    const signUpSignInUrl = computed(() => addFavoriteStudyParam(endpoints.value.SignUpSignIn));
    const signInExternalUrl = computed(() => addFavoriteStudyParam(endpoints.value.SignInExternal));

    return {
      labels,
      endpoints,
      signUpSignInUrl,
      signInExternalUrl,
    };
  },
});
